import React from 'react';
import { Grid, Segment, Image } from 'semantic-ui-react';
import { connect } from 'react-redux';
import styles from './DesktopFooter.styles';
import classes from './desktopFooter.css';
import DesktopFooterLinks from './DesktopFooterLinks';
import NewsletterSignUp from './NewsletterSignUp';
import TextBlurb from './TextBlurb';
import MenuType from '../../../../lib/proptypes/menu.proptypes';
import twIcon from '../../../../assets/images/tw_orange.svg';
import fbIcon from '../../../../assets/images/fb_orange.svg';
import podIcon from '../../../../assets/images/podcast.svg';

const DesktopFooter = ({ menu }) => (
  <Segment basic style={styles.footerSegment}>
    <Grid>
      <Grid.Row>
        <Grid.Column width={11}>
          <div className={classes.footerLeftLabel}>
            <span className={classes.footerLeftLabelText}>Don{'\u2019'}t miss a thing</span>
            <Image
              src={fbIcon}
              className={classes.icon}
              inline
              as="a"
              href="https://www.facebook.com/thehuddle"
              target="_blank"
            />
            <Image
              src={twIcon}
              className={classes.icon}
              inline
              as="a"
              href="https://www.twitter.com/TheHuddle"
              target="_blank"
            />
            <Image
              src={podIcon}
              className={classes.icon}
              inline
              as="a"
              href="https://thehuddle.com/category/fantasy-football-player-analysis-tips-advice-picks/fantasy-football-podcast/"
              target="_blank"
            />
          </div>
          <DesktopFooterLinks menu={menu} />
        </Grid.Column>
        <NewsletterSignUp />
      </Grid.Row>
      <Grid.Column width={11}>
        <TextBlurb />
      </Grid.Column>
    </Grid>
  </Segment>);

const mapStateToProps = state => ({
  menu: state.nav.footer,
  isLoggedIn: state.auth.loggedIn,
});

DesktopFooter.propTypes = {
  menu: MenuType.isRequired,
};

export default connect(mapStateToProps)(DesktopFooter);



// WEBPACK FOOTER //
// ./src/app/components/Footer/DesktopFooter/DesktopFooter.js